import clsx from "clsx";
import { useState } from "react";

import { ArrowRight, Search } from "@components/Icons";
import Spinner from "@components/Spinner";

const SearchInput = ({
	onCommit = (value) => null,
	isFetching = false,
	initialValue = "",
	noMargin,
	className = "",
}) => {
	const [value, setValue] = useState(initialValue);

	const handleChange = (ev) => {
		const newValue = ev.target.value;
		setValue(newValue);
	};

	const handleCommit = () => {
		onCommit(value);
	};

	const handleKeyDown = (ev) => {
		if (ev.key === "Enter") {
			handleCommit();
		}
	};

	return (
		<div
			className={clsx(
				"relative",
				"w-full lg:max-w-[400px] border h-15",
				className,
				{
					"md:ml-15": !noMargin,
				}
			)}
		>
			<div
				className={clsx(
					"absolute w-5.5 h-5.5 flex items-center justify-center top-[17px] left-4 -scale-x-100"
				)}
			>
				<Search />
			</div>
			<input
				className={clsx(
					"form-input",
					"pl-12 pr-4 text-left cursor-default h-full w-full bg-white-01 appearance-none",
					"focus:ring-none"
				)}
				type="search"
				value={value}
				onChange={handleChange}
				onKeyDown={handleKeyDown}
				placeholder="Search"
			/>
			{!isFetching && (
				<button
					onClick={handleCommit}
					className={clsx(
						"absolute w-5 h-5 flex items-center justify-center top-[17px] right-4",
						"transition-transform hover:translate-x-1"
					)}
				>
					<ArrowRight />
				</button>
			)}
			{isFetching && (
				<div
					className={clsx(
						"absolute w-5 h-5 flex items-center justify-center top-[17px] right-4"
					)}
				>
					<Spinner />
				</div>
			)}
		</div>
	);
};

export default SearchInput;
